import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import * as _ from "lodash";

require('./bringoz-duration-mins-hours-input.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-duration-mins-hours-input',
  templateUrl: './bringoz-duration-mins-hours-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozDurationMinsHoursInputComponent implements OnInit, OnChanges  {

  @Input() valueMs: number | null = 0;
  @Output() valueMsChange = new EventEmitter<number | null>();

  @Input() disabled = false;
  @Input() normalizeMinutes = true;
  @Input() hoursTestId?: string;
  @Input() minutesTestId?: string;

  hours = 0;
  minutes = 0;

  ngOnInit(): void {
    this.syncFromMs(this.valueMs);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['valueMs']) {
      this.syncFromMs(changes['valueMs'].currentValue);
    }
  }

  onHoursChange(value: any): void {
    this.hours = this.toNonNegInt(value);
    this.emitMs();
  }

  onMinutesChange(value: any): void {
    this.minutes = this.toNonNegInt(value > 59 ? 59 : value);
    this.emitMs();
  }

  blockNonIntegers(e: KeyboardEvent) {
    // Block decimal separators, exponent, sign
    const blocked = ['.', ',', 'e', 'E', '+', '-'];
    if (blocked.includes(e.key)) e.preventDefault();
  }

  private syncFromMs(ms: number | null): void {
    const safeMs = (ms == null || !Number.isFinite(ms)) ? 0 : Math.max(0, ms);
    const totalMinutes = Math.floor(safeMs / 60000);

    this.hours = Math.floor(totalMinutes / 60);
    this.minutes = totalMinutes % 60;
  }

  private emitMs(): void {
    let h = this.hours;
    let m = this.minutes;

    if (this.normalizeMinutes) {
      h += Math.floor(m / 60);
      m = m % 60;

      // keep UI consistent
      this.hours = h;
      this.minutes = m;
    }

    const ms = (h * 60 + m) * 60000;
    this.valueMsChange.emit(ms);
  }

  private toNonNegInt(v: any): number {
    if (v === '' || v == null) return 0;
    const n = Math.floor(Number(v));
    return Number.isFinite(n) ? Math.max(0, n) : 0;
  }


}
